const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-list') &&
		document.querySelectorAll('.js-media-list').length > 0
	) {
		document.querySelectorAll('.js-media-list').forEach((elem) => {
			const mediaListId = elem.dataset?.jsMediaListId
			const mediaSublist = Array.from(
				document.querySelectorAll('.js-media-sublist')
			).find(
				(subElem) =>
					subElem.dataset?.jsMediaListId === mediaListId && subElem.swiper
			)

			const autoplay = elem.dataset.autoplay == 'true' ? true : false
			let autoplaySettings
			const stopAutoplay = elem.dataset.stopAutoplay == 'true' ? true : false
			const delay = elem.dataset.delay * 1000
			const speed = elem.dataset.speed * 1000
			const id = elem.dataset.section
			
			if (autoplay) {
				autoplaySettings = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
						waitForTransition: true,
					},
				}
			} else {
				autoplaySettings = {}
			}
			let slider = new Swiper(elem, {
				slidesPerView: 1,
				spaceBetween: 1,
				autoHeight: true,
				speed: speed,
				navigation: {
					nextEl: `#${id}-slider .product__slider-nav .swiper-button-next`,
					prevEl: `#${id}-slider .product__slider-nav .swiper-button-prev`
				},
				pagination: {
					el: `#${id}-slider .product__pagination`,
					type: 'bullets',
					clickable: true,
				},
				thumbs: {
					swiper: mediaListId && mediaSublist ? mediaSublist.swiper : '',
				},
				on: {
					init: function () {
						elem.style.setProperty('--bullet-duration', `${delay}ms`)
						document.body.style.setProperty(
							'--bullet-duration-product-modal',
							`${delay}ms`
						)
					},
					slideChangeTransitionStart: function () {
						if (mediaListId && mediaSublist) {
							mediaSublist.swiper.slideTo(this.activeIndex)
						}
					},
					slideChange: function () {
						window.pauseAllMedia();
						this.params.noSwiping = false;
						const activeIndex = this.activeIndex;
						elem.style.setProperty('--bullet-duration', `${delay + speed}ms`)
						let allBullets = this.el.querySelectorAll(
							'.swiper-pagination-bullet'
						)

						if (allBullets && allBullets.length > 0) {
							allBullets.forEach((item) => {
								item.classList.remove('swiper-pagination-bullet-active')
							})
							allBullets[this.activeIndex].classList.add(
								'swiper-pagination-bullet-active'
							)
						}

						let slieCount = this.el.querySelectorAll(
							'.product__pagination-count'
						)
						if( slieCount && slieCount.length > 0 ){
							slieCount.forEach((slieEle)=>{
								slieEle.querySelector('.current_slide').innerHTML = activeIndex + 1;
							});
						}

						document.body.style.setProperty(
							'--bullet-duration-product-modal',
							`${delay + speed}ms`
						)

						if (
							document.querySelector('.js-popup-slider') &&
							document.querySelector('.js-popup-slider').swiper
						) {
							document
								.querySelector('.js-popup-slider')
								.swiper.slideTo(this.activeIndex)
						}
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							this.slides[this.activeIndex]
								.querySelector('.shopify-model-viewer-ui__button--poster')
								.removeAttribute('hidden')
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							if (
								!this.slides[this.activeIndex]
									.querySelector('model-viewer')
									.classList.contains('shopify-model-viewer-ui__disabled')
							) {
								this.params.noSwiping = true
								this.params.noSwipingClass = 'swiper-slide'
							} else {
								this.params.noSwiping = false
							}
						}
					},
				},
				...autoplaySettings,
			})

			if (autoplay && stopAutoplay) {
				const sliderWrapper = document.querySelector('.product__main')
				sliderWrapper.addEventListener('mouseenter', () => {
					document
						.querySelector('.product__main .swiper-pagination-bullet-active')
						.classList.remove('animation-start')
					document
						.querySelector('.product__main .swiper-pagination-bullet-active')
						.classList.add('animation-none')
				})
				sliderWrapper.addEventListener('mouseleave', () => {
					document
						.querySelector('.product__main .swiper-pagination-bullet-active')
						.classList.remove('animation-none')
					document
						.querySelector('.product__main .swiper-pagination-bullet-active')
						.classList.add('animation-start')
				})
			}

			if (isUpdate) {
				setTimeout(function () {
					slider.update()
				}, 800)
			}
		})
	}
}

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-sublist') &&
		document.querySelectorAll('.js-media-sublist').length > 0
	) {
		document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
			const box = document.querySelector('.js-media-sublist')

			const mainImg = document.querySelector('.product__media-list')
			const mainImgHeight = mainImg.offsetHeight
			const subitems = document.querySelectorAll('.product__media-subitem')
			const subitemsWidth = subitems[0].offsetWidth
			const subitemsHeight = subitemsWidth / 0.775 + 16
			const subitemsCountInView = mainImgHeight / subitemsHeight

			let perViewDesktopPlus = subitems.length > 6 ? 5.8 : subitems.length
			let perViewDesktop = subitems.length > 5 ? 5 : subitems.length
			let perViewTablet = subitems.length > 3 ? 3.9 : subitems.length
			let perViewLaptop = subitems.length > 4 ? 3.8 : subitems.length
			let perViewLarge = subitems.length > 8 ? 7.8 : subitems.length

			perViewDesktopPlus = perViewDesktop = perViewLaptop = 6;

			const perView = 6;
			/*const perView =
				box.dataset.sectionLayout == 'container' ? perViewTablet : perViewLarge
			perViewDesktopPlus =
				box.dataset.sectionLayout == 'container'
					? perViewTablet
					: perViewDesktopPlus*/

			let subSlider = new Swiper(elem, {
				slidesPerView: 3.5,
				spaceBetween: 10,
				direction: 'vertical',
				freeMode: false,
				watchSlidesProgress: true,
				autoHeight: true,
				centeredSlides: false,
				centeredSlidesBounds: false,
				slideToClickedSlide: true,
				updateOnWindowResize: true,
				on: {
					touchEnd: function (s, e) {
						let range = 5
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY)
						if (diff < range || diff > -range) s.allowClick = true
					},
				},
				navigation: {
					nextEl: '.thumb-next-btn',
					prevEl: '.thumb-prev-btn',
				},
				breakpoints: {
					990: {
						spaceBetween: 10,
						direction: 'vertical',
						slidesPerView: 3,
						centeredSlides: true,
						centeredSlidesBounds: true,
						slideToClickedSlide: true,
					},
					1200: {
						spaceBetween: 10,
						direction: 'vertical',
						slidesPerView: 4,
					},
					1366: {
						spaceBetween: 10,
						direction: 'vertical',
						slidesPerView: 5,
					},
					1600: {
						spaceBetween: 10,
						direction: 'vertical',
						slidesPerView:
							box.dataset.sectionLayout == 'container'
								? perViewTablet
								: perViewDesktop,
					},
					1920: {
						spaceBetween: 10,
						direction: 'vertical',
						slidesPerView: perViewDesktopPlus,
					},
					2300: {
						spaceBetween: 10,
						direction: 'vertical',
						slidesPerView: perView,
					},
				},
			})

			const sliderResizeObserve = new ResizeObserver((entries) => {
				const [entry] = entries
				setTimeout(() => {
					const sliders = document.querySelectorAll('.js-media-list')
					const thumbs = document.querySelectorAll('.product__media-sublist')
					if (sliders.length > 0 && thumbs.length > 0) {
						if (index >= 0 && index < sliders.length) {
							const sliderHeight = sliders[index].getBoundingClientRect().height
							thumbs[index].style.height = `${sliderHeight - 1}px`
						}
					}
				}, 400)
			})
			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))
			if (document.querySelector('.featured-product'))
				sliderResizeObserve.observe(document.querySelector('.featured-product'))

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update()
				}, 800)
			}
		})
	}
}

const popupSliderInit = (isUpdate) => {
	if (document.querySelector('.js-popup-slider')) {
		let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
			slidesPerView: 1,
			navigation: {
				nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
				prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
			},
			pagination: {
				el: '.product-media-modal .product__pagination',
				type: 'bullets',
				clickable: true,
			},
			on: {
				afterInit: function () {
					if (document.querySelector('.product__outer--slideshow')) {
						document
							.querySelectorAll('.product__media-list .product__media-toggle')
							.forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document
											.querySelector('.js-popup-slider')
											.swiper.slideTo(index)
									}
								})
							})
					}
				},
				slideChange: function () {
					window.pauseAllMedia()
					this.params.noSwiping = false
					document
						.querySelector('.product-media-modal__content')
						.classList.remove('zoom')
				},
				touchMove: function () {
					document
						.querySelector('.product-media-modal__content')
						.classList.remove('zoom')
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector('model-viewer')) {
						this.slides[this.activeIndex]
							.querySelector('.shopify-model-viewer-ui__button--poster')
							.removeAttribute('hidden')
					}
				},
			},
		})

		if (isUpdate) {
			setTimeout(function () {
				popupSlider.update()
			}, 800)
		}
	}
}

if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute(
			'content',
			'width=device-width, initial-scale=1, maximum-scale=1'
		)
}

function getFocusableElements(container) {
	if (!container) return []
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	)
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', 'false')

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open')
		)
	})

	if (summary.closest('header-drawer')) return
	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	if (elementToFocus) elementToFocus.focus()
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*'
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => video.pause())
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus && !elementToFocus.classList.contains('card-focused'))
		elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', { bubbles: true })
		let timeOut;

		this.querySelectorAll('button').forEach((button) => {
			this.setMinimumDisable()

			button.addEventListener('click', this.onButtonClick.bind(this))
		})

		var eventList = ['paste', 'input']
		const this_ele = this;
		for (event of eventList) {
			this.input.addEventListener(event, function (e) {				
				const numberRegex = /^0*?[1-9]\d*$/;
				
				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ''
				) {
					e.currentTarget.value;					
				} else {
					e.currentTarget.value = 1
				}

				if( this.previousElementSibling ){
					if ( e.currentTarget.value === 1 || e.currentTarget.value === '') {
						this.previousElementSibling.classList.add('disabled')
					} else {
						this.previousElementSibling.classList.remove('disabled')
					}
				}				
				let timeOut = 650;
				clearTimeout(timeOut);
				if( window.innerWidth < 750 ){					
					if( e.currentTarget.value === '' ){						
						timeOut = 1000;
					}
				}				
				const currentTarget = e.currentTarget;				
				timeOut = setTimeout(() => { this_ele.maxQty(e, currentTarget); }, timeOut);
				
			})
		}

		this.input.addEventListener('focusout', function (e) {
			if (e.currentTarget.value === '') {
				e.currentTarget.value = 1
			}

			this_ele.maxQty(e, e.currentTarget);
		})
	}

	maxQty(e, input_ele){
		const eleParentNode = input_ele.closest('quantity-input').querySelector('.quantity-unit');
		let qty_add = input_ele.value, 
		qty_max = eleParentNode ? eleParentNode.dataset.max : null,
		qty_max_length = qty_max != null && eleParentNode ? eleParentNode.dataset.maxQty : null,
		qty_ft = input_ele.closest('quantity-input').querySelector('[data-ft]'), 		
		pass_condition = false,
		min_value = Number(input_ele.min), tempvalue = 0;	

		if( min_value && qty_add < min_value ){
			qty_add = min_value;
			e.type != 'input' && (input_ele.value = min_value);
			e.type == 'input' && (tempvalue = min_value);
		}
		
		if( qty_max_length != null && qty_max_length.length > 0 ){
			qty_max_length = Number(qty_max_length);
			pass_condition = qty_add > qty_max_length;
			this.callError(pass_condition, this, qty_max_length);			
		}

		const input_value = tempvalue != 0 ? tempvalue : input_ele.value;
		if( qty_ft ){
			let qty_ft_value = qty_ft.dataset.ft;	
			const o_unit = qty_ft.dataset.unit ? qty_ft.dataset.unit : 'ft';
			qty_ft.innerHTML = `(${ qty_ft_value * input_value }) ${ o_unit }`;
			pass_condition ? this.callError( pass_condition, this) :
				this.callError( (qty_ft_value * input_value) >= (qty_max + 1), this, input_value);
		}

		if(input_ele.closest('.purchase-card') && input_ele.closest('.length-active') == null){
			const pruchase_card = input_ele.closest('.purchase-card');
			const price = pruchase_card.querySelector('.price').dataset.price;
			pruchase_card.querySelector('.price').innerHTML = formatMoney(input_value * price);
		}

		this.setMinimumDisable()

		if( input_ele.value.length > 3 ){
			input_ele.style.width = (32 + ( input_ele.value.length - 3 ) * 10)+'px';
		}else{
			input_ele.style.width = '';
		}
		this.qtyCalculation(input_ele, input_ele.value);
	}

	setMinimumDisable() {
		const hasLength = this.closest('.length-active') != null,
					currentPEle = this.closest('.fieldset_qty--wrapper');
		if( this.input.closest('form[action*="/cart"]') ){
			return;
		}
		if (this.input.value == 1) {			
			if( hasLength && currentPEle ){
				const clickedEvent = new Event('click', { bubbles: true }),
				length = currentPEle.closest('.quantity-box').querySelectorAll('.fieldset_qty--wrapper').length;
				currentPEle.querySelector('.inactive-item')?.dispatchEvent(clickedEvent);
				if( length > 1 ){
					currentPEle.querySelector('.delete-qty-icon').dispatchEvent(clickedEvent);
				}else{
					this.querySelector('button[name="minus"]').classList.add('disabled');
				}
				this.input.value = 1;
			}else{
				this.querySelector('button[name="minus"]').classList.add('disabled')
			}			
		} else {
			this.querySelector('button[name="minus"]').classList.remove('disabled')
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value,  qty_input_ele = event.target.closest('quantity-input');		
		const step = this.input.getAttribute('step') != null ? Number(this.input.getAttribute('step')) : 1;		
		
		event.target.name === 'plus' ||
		event.target.classList.contains('quantity__button_plus')
			? this.input.stepUp()
			: this.input.stepDown()		

		let qty_add = this.input.value,
				qty_max = qty_input_ele.querySelector('.quantity-unit') ? qty_input_ele.querySelector('.quantity-unit').dataset.max : null,
				qty_max_length = qty_max != null && qty_input_ele.querySelector('.quantity-unit') ? qty_input_ele.querySelector('.quantity-unit').dataset.maxQty : null,
				qty_ft = qty_input_ele.querySelector('[data-ft]'), pass_condition = false;
		
		if( qty_max_length != null && qty_max_length.length > 0 ){
			qty_max_length = Number(qty_max_length);
			pass_condition = qty_add > qty_max_length;
			this.callError(pass_condition, this, previousValue);
		}
		if( qty_ft ){
			let qty_ft_value = qty_ft.dataset.ft;
			const o_unit = qty_ft.dataset.unit ? qty_ft.dataset.unit : 'ft';			
			qty_ft.innerHTML = `(${ qty_ft_value * this.input.value }) ${ o_unit }`;
			pass_condition ? this.callError( pass_condition, this, previousValue) :
				this.callError( (qty_ft_value * this.input.value) >= (qty_max + 1), this, this.input.value);
		}

		if(this.input.closest('.purchase-card') && this.input.closest('.length-active') == null){
			const pruchase_card = this.input.closest('.purchase-card');
			const price = pruchase_card.querySelector('.price').dataset.price;
			pruchase_card.querySelector('.price').innerHTML = formatMoney(this.input.value * price);
		}		
		
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent)

		this.setMinimumDisable()

		
		if( this.input.closest('cart-drawer')){
			let inpu_length = this.input.value.length
			if( inpu_length > 1 ){
				this.input.style.minWidth = (10 + ( inpu_length ) * 5.5)+'px';	
			}else{
				this.input.style.minWidth = '';	
			}
		} else if( this.input.value.length > 3 ){
			this.input.style.width = (32 + ( this.input.value.length - 3 ) * 10)+'px';
		}else if( this.input.value.length > 1 && document.querySelector('body.template-cart') ){			
			this.input.style.minWidth = (20 + ( this.input.value.length - 1 ) * 10)+'px';
		}else{
			this.input.style.width = '';
			this.input.style.minWidth = '';
		}		

		this.qtyCalculation(this.input, previousValue);
	}

	callError(_check_condition, ths_ele, val, in_val = null){
		if ( _check_condition ){
			ths_ele.closest('.quantity-box').querySelector('.error-message').classList.remove('hide');
			ths_ele.input.value = in_val == null ? val: in_val;
			ths_ele.querySelector('button[name="plus"]').classList.add('disabled');
		}else{
			ths_ele.querySelector('button[name="plus"]').classList.remove('disabled');
			ths_ele.closest('.quantity-box').querySelector('.error-message').classList.add('hide');
		}
	}

	qtyCalculation(input, preValue){		
		const input_lent_ele = input.closest('.length-active');
		if( input_lent_ele == null ){
			if( typeof updateBtnPrice == 'function' ) updateBtnPrice(input);
			return;
		}
		let multi_vari_ids = [];
		
		input_lent_ele.querySelectorAll('.fieldset_qty--wrapper[data-variant-id]').forEach((ele)=>{
			multi_vari_ids.push(ele.dataset.variantId);
		})

		if( multi_vari_ids.length ){
			const unique_vari_ids = [...new Set(multi_vari_ids)];
			unique_vari_ids.forEach(( vari_id )=>{
				var total_qty = 0;
				var has_max_qty = input_lent_ele.querySelector('.fieldset_qty--wrapper[data-variant-id="'+vari_id+'"][data-max-qty]') ? 
														input_lent_ele.querySelector('.fieldset_qty--wrapper[data-variant-id="'+vari_id+'"][data-max-qty]').dataset.maxQty : null;
				input_lent_ele.querySelectorAll('.fieldset_qty--wrapper[data-variant-id="'+vari_id+'"]').forEach((ele)=>{
					total_qty = total_qty + Number(ele.querySelector('.quantity__input').value);
				});
				if( has_max_qty != null ){
					has_max_qty = Number(has_max_qty)
					if(total_qty > has_max_qty){
						console.log('Max qantity reached.');
						input.value = preValue;
					}
				}
				//console.log('total_qty', vari_id, '= ', total_qty);
			})
		}

		if(this.input.closest('.purchase-card')){
			const pruchase_card = this.input.closest('.purchase-card');
			const price = pruchase_card.querySelector('.price').dataset.price;
			pruchase_card.querySelector('.price').innerHTML = formatMoney(this.input.value * price);
		}

		if( typeof updateBtnPrice == 'function' ) updateBtnPrice(input);
	}
}

//customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

const serializeForm = (form) => {
	const obj = {}
	const formData = new FormData(form)
	for (const key of formData.keys()) {
		obj[key] = formData.get(key)
	}
	return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(
		options['hideElement'] || province_domid
	)

	Shopify.addListener(
		this.countryEl,
		'change',
		Shopify.bind(this.countryHandler, this)
	)

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (let i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

const body = document.body;
let bodyScrollTop = null;
let locked = false;

function getScrollbarWidth() {
	return window.innerWidth - document.documentElement.clientWidth;
}

function preventScroll(e) {
	e.preventDefault();
}

 function lockScroll () {
	bodyScrollTop = (typeof window.pageYOffset !== 'undefined') ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

	var scrollBarWidth = getScrollbarWidth();
	body.style.paddingRight = scrollBarWidth + 'px';

	body.classList.add('scroll-locked');
	body.style.setProperty('--scroll', `${-bodyScrollTop + 'px'}`);
	//body.style.top = -bodyScrollTop + 'px';
	locked = true;

	document.addEventListener('scroll', preventScroll, { passive: false });
};

function unlockScroll() {
	body.classList.remove('scroll-locked');
	//body.style.top = '';
	body.style.setProperty('--scroll', `${-bodyScrollTop + 'px'}`);
	body.style.paddingRight = ''; 
	window.scrollTo(0, bodyScrollTop);

	document.removeEventListener('scroll', preventScroll);
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super()

		this.mainDetailsToggle = this.querySelector('details')
		const summaryElements = this.querySelectorAll('summary')
		this.addAccessibilityAttributes(summaryElements)

		this.headerWrapper = document.querySelector('.header-wrapper')
		if (this.headerWrapper) this.headerWrapper.preventHide = false

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty(
				'--viewport-height',
				`${window.innerHeight}px`
			)

		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))
		this.bindEvents()
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this))
		)
		this.querySelectorAll('button').forEach((button) => {
			if (this.querySelector('.toggle-scheme-button') === button) return
			if (this.querySelector('.header__localization-button') === button) return
			if (this.querySelector('.header__localization-lang-button') === button)
				return
			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute('role', 'button')
			element.setAttribute('aria-expanded', false)
			element.setAttribute('aria-controls', element.nextElementSibling.id)
		})
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = event.target.closest('details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute('open')

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement)
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector('button')
			)

			setTimeout(() => {
				detailsElement.classList.add('menu-opening')
			})
		}
	}

	openMenuDrawer(summaryElement) {
		if (this.headerWrapper) this.headerWrapper.preventHide = true
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})
		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
			})
			this.mainDetailsToggle
				.querySelector('summary')
				.setAttribute('aria-expanded', false)
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			)
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header =
				this.header || document.querySelector('.shopify-section-header')
			const main = document.querySelector('main')
			if (
				main
					?.querySelectorAll('.shopify-section')[0]
					?.classList.contains('section--has-overlay') &&
				!this.header.classList.contains('animate')
			) {
				this.header.classList.remove('color-background-overlay-hidden')
				const colorScheme =
					main
						.querySelectorAll('.shopify-section')[0]
						?.querySelector('[data-header-transparent]')
						?.getAttribute('data-header-transparent-color-scheme') || ''
				if (
					main
						.querySelectorAll('.shopify-section')[0]
						?.querySelector('[data-header-transparent]') &&
					this.header
						.querySelector('.header-wrapper').classList.contains('header-wrapper--full-width')
				) {
					this.header.classList.add('color-background-overlay')
					this.header.classList.add(colorScheme)
				}
			}

			if (this.headerWrapper) this.headerWrapper.preventHide = false
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer()
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details')
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening')
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				detailsElement.removeAttribute('open')
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary')
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
		this.headerWrapper = document.querySelector('.header-wrapper')
		if (this.headerWrapper) this.headerWrapper.preventHide = false

		const overlay = document.querySelector('.header-drawer-overlay');
		if (overlay) {
			overlay.addEventListener('click', (event) => {
				this.closeMenuDrawer(event);
			});
		}
	}

	openMenuDrawer(summaryElement) {
		if (this.headerWrapper) this.headerWrapper.preventHide = true
		this.header =
			this.header || document.querySelector('.shopify-section-header')
		this.borderOffset =
			this.borderOffset ||
			this.closest('.header-wrapper').classList.contains(
				'header-wrapper--border-bottom'
			)
				? 1
				: 0

		const main = document.querySelector('main')
		if (
			main
				?.querySelectorAll('.shopify-section')[0]
				?.classList.contains('section--has-overlay')
		) {
			const colorScheme =
				main
					.querySelectorAll('.shopify-section')[0]
					?.querySelector('[data-header-transparent]')
					?.getAttribute('data-header-transparent-color-scheme') || ''
			this.header.classList.remove('color-background-overlay')
			if (colorScheme) this.header.classList.remove(colorScheme)
			const header = document.querySelector(".shopify-section-header");
			const headerTransparent = header
				.querySelector('.header-wrapper')
				.classList.contains('header-wrapper--full-width')
			const sections = main.querySelectorAll('.shopify-section')
			const sectionFirstChildTransparent = sections[0].querySelector(
				'[data-header-transparent]'
			)
			if (sectionFirstChildTransparent && headerTransparent) {
				this.header.classList.add('color-background-overlay-hidden')
			}
		}

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
			document.querySelector('.header-drawer-overlay').classList.add('active')
		})

		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		//document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
		this.closest('sticky-header').disableScroll();
		lockScroll();
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			document.querySelector('.header-drawer-overlay').classList.remove('active')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
				document.querySelector('.header-drawer-overlay').classList.remove('active')
			})
			this.mainDetailsToggle
				.querySelector('summary')
				.setAttribute('aria-expanded', false)
			/*document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			)*/
			unlockScroll();
			this.closest('sticky-header').enableScroll();
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header =
				this.header || document.querySelector('.shopify-section-header')
			const main = document.querySelector('main')
			if (
				main
					?.querySelectorAll('.shopify-section')[0]
					?.classList.contains('section--has-overlay') &&
				!this.header.classList.contains('animate')
			) {
				this.header.classList.remove('color-background-overlay-hidden')
				const colorScheme =
					main
						.querySelectorAll('.shopify-section')[0]
						?.querySelector('[data-header-transparent]')
						?.getAttribute('data-header-transparent-color-scheme') || ''
				if (
					main
						.querySelectorAll('.shopify-section')[0]
						?.querySelector('[data-header-transparent]') &&
					this.header
						.querySelector('.header-wrapper').classList.contains('header-wrapper--full-width')
				) {
					this.header.classList.add('color-background-overlay')
					this.header.classList.add(colorScheme)
				}
			}

			if (this.headerWrapper) this.headerWrapper.preventHide = false
		}
	}
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			'click',
			this.hide.bind(this, false)
		)
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (
					event.pointerType === 'mouse' &&
					!event.target.closest('deferred-media, product-model, product-modal')
				)
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener,dataid='') {
		opener && opener && opener.closest('.header') && document.querySelector('.overflow-hide .header__mobile-nav-toggle .icon.icon--close') && (
			document.querySelector('.overflow-hide .header__mobile-nav-toggle').click()
		);

		this.openedBy = opener
		const popup = this.querySelector('.template-popup')

		var opener_id = dataid != '' ? dataid : opener.id;
		if(opener_id == 'ModalOpen-mobile-search'){
			document.body.classList.add('search-mobile-open');
		}
		document.body.classList.add('overflow-hidden-modal')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()

		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`) || this.querySelector('deferred-media.product-video-popup') ;
		if (activeMedia && activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
			activeMedia.loadContent();
		}
	}

	hide() {
		let isOpen = false

		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()

		document.querySelectorAll('body > quick-add-modal').forEach((el) => {
			if (el.hasAttribute('open')) {
				isOpen = true
			}
		})

		if (!isOpen) {
			document.body.classList.remove('overflow-hidden-modal')
			document.body.classList.remove('search-mobile-open');
			document.body.dispatchEvent(new CustomEvent('modalClosed'))
		}

		const images = document.querySelector('.product-media-modal__content')

		if (images) {
			images.classList.remove('zoom')
		}
	}
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) modal.show(button)
		})
	}
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this)
		)
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(
				this.querySelector('template').content.firstElementChild.cloneNode(true)
			)

			this.setAttribute('loaded', true)
			window.pauseAllMedia()
			this.appendChild(
				content.querySelector('video, model-viewer, iframe')
			).focus()

			if (
				this.closest('.swiper')?.swiper.slides[
					this.closest('.swiper').swiper.activeIndex
				].querySelector('model-viewer')
			) {
				if (
					!this.closest('.swiper')
						.swiper.slides[
							this.closest('.swiper').swiper.activeIndex
						].querySelector('model-viewer')
						.classList.contains('shopify-model-viewer-ui__disabled')
				) {
					this.closest('.swiper').swiper.params.noSwiping = true
					this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide'
				}
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
	}

	onVariantChange(event) {
		this.getAvailableVariant(event)
		this.updateOptions()
		this.updateMasterId()
		this.toggleAddButton(true, '', false)
		this.updatePickupAvailability()
		this.updateVariantStatuses()

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true)
			this.setUnavailable()
		} else {
			if (!this.closest('floated-form')) {
				this.updateMedia()
			}
			// this.updateURL()
			// this.updateVariantInput()
			// this.resetProductFormState()
			// this.renderProductInfo()
		}
		this.updateURL()
		this.updateVariantInput()
		this.resetProductFormState()
		this.renderProductInfo()		

		this.closest('.productinfo-wrapper:not(.variant-selected)') && (
			this.closest('.productinfo-wrapper').classList.add('variant-selected'),
			this.closest('.product__outer').classList.add('variant-selected_outer')
		);
	}

	getAvailableVariant(event) {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			let fixedOptionValue
			const fieldsets = this.querySelectorAll('fieldset')

			if (event.target.tagName == 'SELECT') {
				fixedOptionValue =
					event.target.options[event.target.selectedIndex].value
			} else if (event.target.tagName == 'INPUT') {
				fixedOptionValue = event.target.value
			}

			fieldsets.forEach((fieldset, index) => {				
				const select = fieldset.querySelector('select[name^="options"]')
				let radio = fieldset.querySelector(
					`input[type="radio"][value="${fixedOptionValue}"]`
				)				
				
				if(radio && radio.closest('.pricing-option') && radio.closest('.pricing-option').classList.contains('hide-sold_out')){
					const first_el = radio.closest('.purchase-option-radio').querySelectorAll('.pricing-option:not(.hide-sold_out)')[0];
					radio = first_el.querySelector(`input[type="radio"][value="${fixedOptionValue}"]`)
				}else if(radio && radio.closest('.items') && radio.closest('.items').classList.contains('hide-sold_out')){
					const first_el = radio.closest('.select-items').querySelectorAll('.items:not(.hide-sold_out)')[0];
					radio = first_el.querySelector(`input[type="radio"][value="${fixedOptionValue}"]`)
				}

				if (select) {
					if (select.name.includes(event.target.name)) {
						this.fixedSelectIndex = index
					}
				} else if (radio) {
					this.fixedSelectIndex = index
				}
				fieldset.querySelector('.product-form__group-name span') && (
					fieldset.querySelector('.product-form__group-name span').innerText = fixedOptionValue
				)
			})

			const fixedOptionValues = Array.from(fieldsets)
				.slice(0, this.fixedSelectIndex + 1)
				.map((fieldset) => {
					const select = fieldset.querySelector('select[name^="options"]')
					if (select) {
						return select.options[select.selectedIndex].value
					}
					let radioSelected = fieldset.querySelector(
						'input[type="radio"]:checked'
					)		

					if (radioSelected) {
						return radioSelected.value
					}
					return null
				})
				.filter((value) => value !== null)				

			this.availableVariant = this.getVariantData().find(
				(variant) =>
					//variant.available &&
					fixedOptionValues.every(
						(value, index) => {
							if( this.dataset.hideSoldOut != "true"){
								return variant[`option${index + 1}`] === value
							} else if ( this.dataset.hideSoldOut == "true" && variant.available != false ) {
								return variant[`option${index + 1}`] === value
							}							
						}
					)
			)
			
			if( this.availableVariant == undefined ){
				if( event.target.closest('.items') ){					
					let close_next_ele = event.target.closest('.items').nextElementSibling
					if( !close_next_ele ){
						close_next_ele = event.target.closest('.select-items').children[0]
					}
					close_next_ele.querySelector('input').checked = true;
					close_next_ele.querySelector('input').dispatchEvent(new Event('change',{ bubbles: true }))
					event.target.closest('.items').classList.add('hide-sold_out')
				}else{
					if( event.target.closest('.pricing-option') ){
						let close_next_ele = event.target.closest('.pricing-option').nextElementSibling;
						if( !close_next_ele ){
							close_next_ele = event.target.closest('.purchase-option-radio').children[0]
						}
						close_next_ele.querySelector('input').checked = true;
						close_next_ele.querySelector('input').dispatchEvent(new Event('change',{ bubbles: true }))
						event.target.closest('.pricing-option').classList.add('hide-sold_out')
					}
				}
			}

			if (!this.availableVariant) {
				this.availableVariant = this.getVariantData().find(
					(variant) =>
						variant.available && variant[`option${this.fixedSelectIndex + 1}`] === fixedOptionValue
				)				
			}
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('.product-variant'))		

		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll('input')).find(
					(radio) => radio.checked
				)?.value
			})
		)		
	}

	updateMasterId(custom_options = null) {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				custom_options != null && (
					this.options = custom_options
				);
				this.options.sort()
				variant.options.sort()

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option
					})
					.includes(false)
			})

			if (
				(!this.currentVariant || !this.currentVariant?.available) &&
				this.availableVariant
			) {
				this.currentVariant = this.availableVariant

				const fieldsets = this.querySelectorAll('fieldset')

				fieldsets.forEach((fieldset, index) => {
					const optionValue = this.currentVariant[`option${index + 1}`]
					const select = fieldset.querySelector('select[name^="options"]')
					const radioToSelect = fieldset.querySelector(
						`input[type="radio"][value="${optionValue}"]`
					)

					if (index != this.fixedSelectIndex) {
						if (select) {
							select.value = optionValue
						} else if (radioToSelect) {
							radioToSelect.checked = true
						}
					}
				})
			}
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	updateMedia(customObj = {}) {
		const curretVari = Object.entries(customObj).length ? customObj : this.currentVariant;
		//if (!this.currentVariant || !this.currentVariant?.featured_media) return
		if( !curretVari || !curretVari?.featured_media ) return

		const swiperWrappers = document.querySelectorAll('.product__media-wrapper')

		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${curretVari.featured_media.id}"]`
				)

				if (elem.querySelector('.js-media-list')) {
					elem
						.querySelector('.js-media-list')
						.swiper.slideTo(
							elem
								.querySelector('.js-media-list')
								.swiper.slides.indexOf(newMedia)
						)
				}
			}
		})
	}

	updateURL() {
		if (!this.classList.contains('featured-product-radios')) {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return
			let win_l_search = window.location.search, search_par_view = '';
			if( win_l_search && win_l_search.indexOf('view=') > -1 ){
				search_par_view = win_l_search.split('view=')[1].split('&&')[0]
			}
			if( window.location.pathname == "/products_preview" ){
				let ser_par = window.location.search.split('&')[0].replaceAll('?','');
				window.history.replaceState(
					{},
					'',
					`${'/products_preview'}?${ ser_par }&variant=${this.currentVariant.id}${ search_par_view !='' ? '&view='+search_par_view : '' }`
				)
			}else{
				window.history.replaceState(
					{},
					'',
					`${this.dataset.url}?variant=${this.currentVariant.id}${ search_par_view !='' ? '&view='+search_par_view : '' }`
				)
			}
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1
		)
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			]
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(':checked').value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled')
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							'[value]',
							input.getAttribute('value')
						)
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')
				}
			}
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	renderProductInfo() {
		const tis_this = this;
		const requestedVariantId = this.currentVariant.id
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section,
		product_wrapper_ele = this.closest('.productinfo-wrapper')

		let win_l_search = window.location.search, search_par_view = '';
		if( win_l_search && win_l_search.indexOf('view=') > -1 ){
			search_par_view = win_l_search.split('view=')[1].split('&&')[0]
		}

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}${ search_par_view !='' ? '&view='+search_par_view : '' }`
		)
		.then((response) => response.text())
		.then((responseText) => {
			// prevent unnecessary ui changes from abandoned selections
			if (!this.currentVariant) return
			if (this.currentVariant.id !== requestedVariantId) return

			let ele_renders = ['.stock-availability', 
				'fieldset[data-filedset-color]',
				'.quantity-box',
				'.delete-btn-wrap .price',
				'.product-form__buttons-row .product-form__submit .price', '.product__sku, .heading-wrapper .product__sku'
			];
			const html = new DOMParser().parseFromString(responseText, 'text/html')
			const lengthfeature = html.querySelector('.main-product[data-length-feature="true"]') != null;
			const destination = document.getElementById(
				`price-${this.dataset.section}`
			)
			const source = html.getElementById(
				`price-${
					this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
				}`
			)
			const skuSource = html.getElementById(
				`Sku-${
					this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
				}`
			)
			const skuDestination = document.getElementById(
				`Sku-${this.dataset.section}`
			)
			const inventorySource = html.getElementById(
				`Inventory-${
					this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
				}`
			)
			const inventoryDestination = document.getElementById(
				`Inventory-${this.dataset.section}`
			)
			const colorNameSource = html.getElementById(
				`ColorName-${
					this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
				}`
			)
			const colorNameDestination = document.getElementById(
				`ColorName-${this.dataset.section}`
			)

			const product__outer = tis_this.closest('.product__outer');
			const has_quick = product__outer.closest('quick-add-modal') != null; 
			
			const notify_me_button =  product__outer.querySelector('.product-form__buttons-row modal-opener[data-modal*="#PopupProNotifyMe-"]');
			const notify_me_button_des =  html.querySelector('.product-form__buttons-row modal-opener[data-modal*="#PopupProNotifyMe-"]');
			
			if(has_quick){
				this.productElement = html.querySelector(
					'section[id^="MainProduct-"]'
				)					
				const sectionId = this.dataset.section.indexOf('quickadd-') > -1 ? this.dataset.section.split('quickadd-')[1] : this.dataset.section.indexOf('quickadd-');					
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					)
				
				this.productElement
					.querySelectorAll('variant-selects, variant-radios')
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId
					})

				const divID =['ModalOpen','ModalClose','PopupProNotifyMe'];
				for (let i = 0; i < divID.length; i++){
					this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						divID[i],
						`${divID[i]}-quickadd`
					)
				}
			}
			ele_renders.forEach((selector, index)=>{
				const ele_selector = product__outer.querySelectorAll('.productinfo-wrapper '+selector).length > 0 ?
					product__outer.querySelectorAll('.productinfo-wrapper '+selector): product__outer.querySelectorAll(selector);
				const rend_selector = html.querySelectorAll('.productinfo-wrapper '+selector).length > 0 ?
					html.querySelectorAll('.productinfo-wrapper '+selector) : html.querySelectorAll(selector);					
				if( ele_selector.length > 0 && rend_selector.length > 0 ){
					ele_selector.forEach((ele_sele_ele, ele_index)=>{
						let input_checked_id = '';							
						if( ele_sele_ele.querySelector('input:checked') ){
							input_checked_id = '#'+ ele_sele_ele.querySelector('input:checked').getAttribute('id');
						}
						if( selector != ".quantity-unit[data-max]" ){
							ele_sele_ele.innerHTML = rend_selector[ele_index].innerHTML;
						}else{
							ele_sele_ele.dataset.max = rend_selector[ele_index].dataset.max;
						}
						
						if( input_checked_id != '' && rend_selector[ele_index].querySelector('input'+input_checked_id) ){
							const ele_input = ele_sele_ele.querySelector('input'+input_checked_id), 
							filedset_ele = ele_input.closest('fieldset');
							ele_input.checked = true;
							filedset_ele.querySelector('.selected-varient') && (
								filedset_ele.querySelector('.selected-varient').innerHTML = ele_input.dataset.value
							);
							filedset_ele.querySelector('.select-selected') && (
								filedset_ele.querySelector('.select-selected').innerHTML = ele_input.parentNode.querySelector('label').innerHTML
							);
							filedset_ele.querySelector('[data-not-selected="true"]') && (									
								filedset_ele.querySelector('[data-not-selected="true"]').dataset.notSelected = "false"
							);
						}
					});
				}
			});

			if( notify_me_button && notify_me_button_des ){
				const modal = document.querySelector('modal-dialog'+notify_me_button.dataset.modal);
				if( !this.currentVariant.available ){
					modal.querySelector('input[name="Variant_title"]').value = this.currentVariant.title;
					modal.querySelector('select') && (
						modal.querySelector('select').value = this.currentVariant.title
					);
				}
			}

			if( document.querySelector('.quantity-box .error-message') ){
				document.querySelector('.quantity-box .error-message').classList.add('hide');
			}
			if( document.querySelector('quantity-input .quantity__button.disabled[name="plus"]') ){
				document.querySelector('quantity-input .quantity__button.disabled[name="plus"]').classList.remove('disabled');
			}				

			if (source && destination) destination.innerHTML = source.innerHTML
			if (inventorySource && inventoryDestination)
				inventoryDestination.innerHTML = inventorySource.innerHTML
			if (skuSource && skuDestination) {
				skuDestination.innerHTML = skuSource.innerHTML
				skuDestination.classList.toggle(
					'visibility-hidden',
					skuSource.classList.contains('visibility-hidden')
				)
			}				

			if (colorNameSource && colorNameDestination)
				colorNameDestination.innerHTML = colorNameSource.innerHTML

			const price = document.getElementById(`price-${this.dataset.section}`)

			if (price) price.classList.remove('visibility-hidden')

			if (inventoryDestination)
				inventoryDestination.classList.toggle(
					'visibility-hidden',
					inventorySource.innerText === ''
				)
			
			if( lengthfeature ){
				if( this.currentVariant.title.indexOf('Spool') < 0 ){
					this.closest('.productinfo-wrapper').querySelector('.quantity-box').classList.add('length-active');
					this.querySelector('[data-filedset-color="true"]') && (
						this.querySelector('[data-filedset-color="true"]').classList.add('hidden'),
						this.querySelector('[data-filedset-color="true"] .select-selected').setAttribute('data-length-feature', '')
					);
				}else{
					this.closest('.productinfo-wrapper').querySelector('.quantity-box').classList.remove('length-active');
					this.querySelector('[data-filedset-color="true"]') && (
						this.querySelector('[data-filedset-color="true"]').classList.remove('hidden'),
						this.querySelector('[data-filedset-color="true"] .select-selected').removeAttribute('data-length-feature', '')
					);
				}
			}

			if( product_wrapper_ele.querySelector('.fieldset_qty--wrapper') ){					
				if ( tis_this.currentVariant.title.indexOf('Spool') > -1 || tis_this.currentVariant.title.indexOf('spool') > -1 ){
					product_wrapper_ele.querySelector('.fieldset_qty--wrapper').classList.add('has-spool');
				}					
			}
			
			this.toggleAddButton( !this.currentVariant.available, window.variantStrings.soldOut, 'notify_me')
			if(document.querySelector('.stock-status') && document.querySelector('.quote-btn')){
				// After the refresh the main colour picker can come back with nothing ticked (e.g. leaving By the Foot
				// for a spool). Tick the colour of the variant now selected so the box does not read "Please select".
				const wa_colour_fs = this.querySelector('fieldset[data-filedset-color="true"]');
				if (wa_colour_fs && !wa_colour_fs.classList.contains('hidden') && !wa_colour_fs.querySelector('input[type="radio"]:checked')) {
					const wa_value = this.currentVariant['option' + (parseInt(wa_colour_fs.dataset.index, 10) + 1)];
					const wa_radio = Array.prototype.find.call(wa_colour_fs.querySelectorAll('input[type="radio"]'), (r) => r.value === wa_value);
					if (wa_radio) {
						wa_radio.checked = true;
						const wa_box = wa_colour_fs.querySelector('.select-selected');
						const wa_label = wa_radio.parentNode.querySelector('label');
						wa_box && wa_label && (wa_box.innerHTML = wa_label.innerHTML, wa_box.dataset.notSelected = 'false');
						wa_colour_fs.querySelector('.selected-varient') && (wa_colour_fs.querySelector('.selected-varient').textContent = wa_value);
					}
				}
				// Quote-only variant (tag, its own box, or a quote-only colour): hide the quantity box with the buy button.
				const wa_qty_box = this.closest('.productinfo-wrapper') && this.closest('.productinfo-wrapper').querySelector('.quantity-box');
				// The section's quote--true/false class (set at page load) hides the spool prices; follow the variant now selected.
				const wa_section = this.closest('.quote--true, .quote--false');
				if (wa_section) {
					const wa_is_quote = document.querySelector('.stock-status').getAttribute('data-status') == 'true';
					wa_section.classList.toggle('quote--true', wa_is_quote);
					wa_section.classList.toggle('quote--false', !wa_is_quote);
				}
				if(document.querySelector('.stock-status').getAttribute('data-status') == 'true'){
					document.querySelector('.quote-btn').nextElementSibling.classList.add('hidden');
					document.querySelector('.quote-btn').classList.remove('hidden');
					wa_qty_box && wa_qty_box.classList.add('hidden');
					// By the Foot normally moves the colour choice into the (now hidden) length rows; keep the main picker so the shopper can change colour.
					this.querySelector('[data-filedset-color="true"]') && this.querySelector('[data-filedset-color="true"]').classList.remove('hidden');
				}else{
					document.querySelector('.quote-btn').nextElementSibling.classList.remove('hidden');
					document.querySelector('.quote-btn').classList.add('hidden');
					wa_qty_box && wa_qty_box.classList.remove('hidden');
					// Coming back from a quote-only colour on By the Foot: carry the colour just picked into the length row.
					const wa_quote_list = document.getElementById('wa-quote-variants');
					const wa_has_quote = wa_quote_list && wa_quote_list.textContent.replace(/[\s\[\]]/g, '') !== '';
					const wa_row_fs = wa_has_quote && wa_qty_box && wa_qty_box.classList.contains('length-active') && wa_qty_box.querySelector('.fieldset_qty--wrapper fieldset[data-index]');
					if (wa_row_fs && wa_row_fs.querySelector('.select-selected.not-active')) {
						// option1/2/3 follow the product's option order; currentVariant.options follows the order on screen.
						const wa_colour = this.currentVariant['option' + (parseInt(wa_row_fs.dataset.index, 10) + 1)];
						const wa_item = Array.prototype.find.call(wa_row_fs.querySelectorAll('.items[data-value]'), (el) => el.dataset.value === wa_colour && el.dataset.waQuote !== 'true');
						wa_item && wa_item.click();
					}
				}
			}
		})
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		const addButtonText = productForm.querySelector('[name="add"] > span')
		const notifyMeButton = productForm.querySelector('.product-notify-me') || null;
		if (!addButton) return

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = window.variantStrings.addToCart
		}

		if( modifyClass == "notify_me" && notifyMeButton ){
			notifyMeButton.classList.add('hide');
			if( modifyClass == "notify_me" && disable){
				notifyMeButton.classList.remove('hide');
			}
		}

		if (!modifyClass) return
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		)
		const addButton = button.querySelector('[name="add"]')
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`
		)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)

		if (!addButton) return
		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (price) price.classList.add('visibility-hidden')
		if (inventory) inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
	}

	resetProductFormState() {
		const productForm = document
			.getElementById(`product-form-${this.dataset.section}`)
			.closest('product-form')
		if (productForm) {
			const quantity = productForm.querySelector('quantity-input')
			if (quantity) quantity.input.value = 1
			productForm?.handleErrorMessage()
		}
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled')
			} else {
				input.classList.add('disabled')
			}
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked
			).value
		})
	}
}

customElements.define('variant-radios', VariantRadios)
customElements.define('quantity-input', QuantityInput)

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll('.field--pass')

		passwordField.forEach((el) => {
			const input = el.querySelector('input')
			const btnWrapper = el.querySelector('.button-pass-visibility')
			const btnOpen = el.querySelector('.icon-eye-close')
			const btnClose = el.querySelector('.icon-eye')

			input.addEventListener('input', () => {
				input.value !== ''
					? (btnWrapper.style.display = 'block')
					: (btnWrapper.style.display = 'none')
			})

			btnOpen.addEventListener('click', () => {
				input.type = 'text'
				btnOpen.style.display = 'none'
				btnClose.style.display = 'block'
			})

			btnClose.addEventListener('click', () => {
				input.type = 'password'
				btnOpen.style.display = 'block'
				btnClose.style.display = 'none'
			})
		})
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			if (this.querySelector('.product-recommendations__loading')) {
				this.querySelector('.product-recommendations__loading').classList.add(
					'loading'
				)
				this.querySelector('.product-recommendations__loading').style.display =
					'flex'
			}

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

					if (this.querySelector('.product-recommendations__empty')) {
						this.querySelector(
							'.product-recommendations__empty'
						).style.display = 'flex'
					}

					/* Color swatches */
					const generateSrcset = (image, widths = []) => {
						const imageUrl = new URL(image['src'])
						return widths
							.filter((width) => width <= image['width'])
							.map((width) => {
								imageUrl.searchParams.set('width', width.toString())
								return `${imageUrl.href} ${width}w`
							})
							.join(', ')
					}

					const createImageElement = (image, classes, sizes, productTitle) => {
						const previewImage = image['preview_image']
						const newImage = new Image(
							previewImage['width'],
							previewImage['height']
						)
						newImage.className = classes
						newImage.alt = image['alt'] || productTitle
						newImage.sizes = sizes
						newImage.src = previewImage['src']
						newImage.srcset = generateSrcset(
							previewImage,
							[165, 360, 533, 720, 940, 1066]
						)
						newImage.loading = 'lazy'
						return newImage
					}

					const checkSwatches = () => {
						document
							.querySelectorAll('.js-color-swatches-wrapper')
							.forEach((wrapper) => {
								wrapper
									.querySelectorAll('.js-color-swatches input')
									.forEach((input) => {
										input.addEventListener('click', (event) => {
											const primaryImage =
												wrapper.querySelector('.media--first')
											const secondaryImage =
												wrapper.querySelector('.media--second')
											const handleProduct = wrapper.dataset.product

											if (event.currentTarget.checked && primaryImage) {
												wrapper
													.querySelector('.js-color-swatches-link')
													.setAttribute(
														'href',
														event.currentTarget.dataset.variantLink
													)
												if (
													wrapper.querySelector(
														'.card__add-to-cart button[name="add"]'
													)
												) {
													wrapper
														.querySelector(
															'.card__add-to-cart button[name="add"]'
														)
														.setAttribute('aria-disabled', false)
													if (
														wrapper.querySelector(
															'.card__add-to-cart button[name="add"] > span'
														)
													) {
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] > span'
															)
															.classList.remove('hidden')
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] .sold-out-message'
															)
															.classList.add('hidden')
													}
													wrapper.querySelector(
														'.card__add-to-cart input[name="id"]'
													).value = event.currentTarget.dataset.variantId
												}
												const currentColor = event.currentTarget.value

												jQuery.getJSON(
													window.Shopify.routes.root +
														`products/${handleProduct}.js`,
													function (product) {
														const variant = product.variants.filter(
															(item) =>
																item.featured_media != null &&
																item.options.includes(currentColor)
														)[0]

														if (variant) {
															const newPrimaryImage = createImageElement(
																variant['featured_media'],
																primaryImage.className,
																primaryImage.sizes,
																product.title
															)

															if (newPrimaryImage.src !== primaryImage.src) {
																let flag = false
																if (secondaryImage) {
																	const secondaryImagePathname = new URL(
																		secondaryImage.src
																	).pathname
																	const newPrimaryImagePathname = new URL(
																		newPrimaryImage.src
																	).pathname

																	if (
																		secondaryImagePathname ==
																		newPrimaryImagePathname
																	) {
																		primaryImage.remove()
																		secondaryImage.classList.remove(
																			'media--second'
																		)
																		secondaryImage.classList.add('media--first')
																		flag = true
																	}
																}
																if (flag == false) {
																	primaryImage.animate(
																		{ opacity: [1, 0] },
																		{
																			duration: 200,
																			easing: 'ease-in',
																			fill: 'forwards',
																		}
																	).finished
																	setTimeout(function () {
																		primaryImage.replaceWith(newPrimaryImage)
																		newPrimaryImage.animate(
																			{ opacity: [0, 1] },
																			{ duration: 200, easing: 'ease-in' }
																		)
																		if (secondaryImage) {
																			secondaryImage.remove()
																		}
																	}, 200)
																}
															}
														}
													}
												)
											}
										})
									})
							})
					}

					checkSwatches()

					const addClasses = (slider) => {
						const sliderWrapper = slider.querySelector(
							'.product-recommendations__wrapper'
						)
						const slides = slider.querySelectorAll(
							'.product-recommendations__item'
						)

						slider.classList.add('swiper')
						if (sliderWrapper) sliderWrapper.classList.add('swiper-wrapper')

						if (slides.length > 1) {
							slides.forEach((slide) => {
								slide.classList.add('swiper-slide')
							})
						}
					}

					const initSlider = () => {
						const productSlider = () => {
							const productSliders = Array.from(
								document.querySelectorAll('.products-slider')
							)
							if (productSliders.length === 0) return
							productSliders.forEach((slider) => {
								const sectionId = slider.dataset.id
								const perRow = +slider.dataset.perRow
								let perRowTablet
								let perRowDesktop
								let perRowLarge
								const speed = slider.dataset.speed * 1000
								const delay = slider.dataset.delay * 1000
								const productLimit = +slider.dataset.productLimit
								const autoplay = toBoolean(slider.dataset.autoplay)
								const stopAutoplay = toBoolean(slider.dataset.stopAutoplay)
								const showArrows = toBoolean(slider.dataset.showArrows)
								const productCount = +slider.dataset.productCount
								let autoplayParm = {}
								let arrowsParm = {}
								let paginationParm = {}

								if (
									autoplay &&
									productCount > perRow &&
									productLimit > perRow
								) {
									autoplayParm = {
										autoplay: {
											delay: delay,
											pauseOnMouseEnter: stopAutoplay,
											disableOnInteraction: false,
										},
									}
								}
								if (showArrows) {
									arrowsParm = {
										navigation: {
											nextEl: `#${sectionId} .swiper-button-next`,
											prevEl: `#${sectionId} .swiper-button-prev`,
										},
									}
								}
								const containerOuter =
									(document.body.offsetWidth -
										document.querySelector(`#${sectionId} .popular-product__wrapper`)
											.offsetWidth) /
									2

								document.querySelector(
									`#${sectionId} .swiper-pagination`
								).style.paddingLeft = `${containerOuter}px`
								const buttonNext = document.querySelector(
									`#${sectionId} .swiper-button-next`
								)
								const buttonPrev = document.querySelector(
									`#${sectionId} .swiper-button-prev`
								)
								// if (buttonNext && buttonPrev) {
								// 	if (window.innerWidth >= 1200) {
								// 		const buttonOffset = +containerOuter - 21

								// 		buttonNext.style.right = `${buttonOffset}px`
								// 		buttonPrev.style.left = `${buttonOffset}px`
								// 	} else {
								// 		buttonNext.style.right = `${containerOuter + 21}px`
								// 		buttonPrev.style.left = `${containerOuter + 21}px`
								// 	}
								// }

								const sectionHeader = document.querySelector(
									'.popular-products .popular-product__wrapper'
								)
								let columnGaps = (perRow - 1) * 16
								let oneCard = (sectionHeader.offsetWidth - columnGaps) / perRow
								let perViewRightOffset = +(
									(containerOuter * 2) /
									oneCard
								).toFixed(3)

								perViewRightOffset =
									+((containerOuter * 2) / oneCard).toFixed(3) -
									+(perViewRightOffset / oneCard) * 16

								if (perRow == 1) {
									perRowTablet =
										perRowDesktop =
										perRowLarge =
											1 + perViewRightOffset
								} else {
									let columnGapsTablet = (2 - 1) * 16
									let columnGaps = (3 - 1) * 16
									let oneCard = (sectionHeader.offsetWidth - columnGaps) / 3
									let oneCardTablet =
										(sectionHeader.offsetWidth - columnGapsTablet) / 2

									let perViewRightOffsetDekstop =
										+((containerOuter * 2) / oneCard).toFixed(3) -
										+(perViewRightOffset / oneCard) * 16
									let perViewRightOffsetTablet =
										+((containerOuter * 2) / oneCardTablet).toFixed(3) -
										+(perViewRightOffset / oneCardTablet) * 16

									perRowTablet = 2 + perViewRightOffsetTablet
									perRowDesktop = 3 + perViewRightOffsetDekstop
									perRowLarge = perRow + perViewRightOffset
								}
								if (perRow == 2) {
									perRowTablet =
										perRowDesktop =
										perRowLarge =
											2 + perViewRightOffset
								}

								if (productCount > 4) {
									paginationParm = {
										pagination: {
											el: `#${sectionId} .swiper-pagination`,
											clickable: true,
										},
									}
								}

								let swiperParms = {
									speed: speed,
									keyboard: true,
									slidesPerView: 1.05,
									spaceBetween: 10,
									// slidesOffsetBefore: containerOuter,
									breakpoints: {
										375: {
											slidesPerView: 2,
										},
										750: {
											spaceBetween: 16,
											slidesPerView: 2,
										},
										990: {
											spaceBetween: 16,
											slidesPerView: 3,
										},
										1200: {
											spaceBetween: 16,
											slidesPerView: 5,
										},
										1800: {
											spaceBetween: 16,
											slidesPerView: 5,
										},
										2000: {
											spaceBetween: 16,
											slidesPerView: 5,
										},
									},
									...paginationParm,
									...arrowsParm,
									...autoplayParm,
								}
								function changeBtnPosition() {
									if (window.innerWidth < 750) {
										document
											.querySelectorAll(`#${sectionId} .swiper-button`)
											.forEach((button) => {
												button.style.display = 'none'
											})
										return
									}
									const image1 = document.querySelectorAll(
										`#${sectionId} .swiper .product-card .card`
									)[0]

									if (image1) {
										document
											.querySelectorAll(`#${sectionId} .swiper-button`)
											.forEach((button) => {
												button.style.display = 'block'
												// button.style.top = image1.offsetHeight / 2 - 15 + 'px'
											})
									}
								}
								const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms)

								swiper.on('slideChange', function () {
									let allBullets = document.querySelectorAll(
										`#${sectionId} .swiper-pagination-bullet`
									)
									if (allBullets && allBullets.length > 0) {
										allBullets.forEach((item) => {
											item.classList.remove('swiper-pagination-bullet-active')
										})
										allBullets[swiper.activeIndex].classList.add(
											'swiper-pagination-bullet-active'
										)
									}
								})
								changeBtnPosition()
							})
						}

						function toBoolean(string) {
							return string === 'true' ? true : false
						}
						if (document.querySelector('product-recommendations') !== null) {
							const initslider = setInterval(() => {
								if (
									document
										.querySelector('product-recommendations')
										.querySelector('.swiper') !== null
								) {
									if (
										document
											.querySelector('product-recommendations')
											.querySelector('.swiper')
											.classList.contains('swiper-initialized')
									) {
										clearInterval(initslider)
									}
									productSlider()
								}
							}, 100)
						}
						productSlider()
						document.addEventListener('shopify:section:load', function () {
							productSlider()
						})
						window.addEventListener('resize', function () {
							productSlider()
						})
					}

					//const destroySlider = () => {
					//	const slider = this.querySelector('.swiper--recomend-products')

					//	if (slider) {
					//		removeClasses(slider)
					//	}
					//}

					const initSection = () => {
						const resizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries
							initSlider()
						})

						resizeObserver.observe(this)
					}

					initSection()
				})
				.catch((e) => {
					console.error(e)
				})
				.finally(() => {
					if (this.querySelector('.product-recommendations__loading')) {
						this.querySelector(
							'.product-recommendations__loading'
						).classList.remove('loading')
						this.querySelector('.product-recommendations__loading').remove()
					}
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 200px 0px',
		}).observe(this)
	}
}

customElements.define('product-recommendations', ProductRecommendations)

class LocalizationForm extends HTMLElement {
	constructor() {
		super()
		this.elements = {
			input: this.querySelector(
				'input[name="locale_code"], input[name="country_code"]'
			),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		}
		this.elements.button.addEventListener('click', this.openSelector.bind(this))
		this.elements.button.addEventListener(
			'focusout',
			this.closeSelector.bind(this)
		)
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

		this.querySelectorAll('a').forEach((item) =>
			item.addEventListener('click', this.onItemClick.bind(this))
		)
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false')
		this.elements.panel.setAttribute('hidden', true)
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		this.hidePanel()
		this.elements.button.focus()
	}

	onItemClick(event) {
		event.preventDefault()
		this.elements.input.value = event.currentTarget.dataset.value
		this.querySelector('form')?.submit()
	}

	openSelector() {
		this.elements.button.focus()
		this.elements.panel.toggleAttribute('hidden')
		this.elements.button.setAttribute(
			'aria-expanded',
			(
				this.elements.button.getAttribute('aria-expanded') === 'false'
			).toString()
		)
	}

	closeSelector(event) {
		if (!this.contains(event.relatedTarget)) {
			this.hidePanel()
		}
	}
}

customElements.define('localization-form', LocalizationForm)
;(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById('MainContent')
		const sections = main.querySelectorAll('.shopify-section')

		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector(
				'[data-header-overlay]'
			)
			const sectionFirstChildTransparent = sections[0].querySelector(
				'[data-header-transparent]'
			)
			const headerGroupSections = document.querySelectorAll(
				'.shopify-section-group-header-group'
			)
			const header = document.querySelector('.shopify-section-header')
			const headerTransparent = header
				.querySelector('.header-wrapper')
				.classList.contains('header-wrapper--full-width')
			const colorScheme = sectionFirstChild?.getAttribute(
				'data-header-transparent-color-scheme'
			)

			if (sectionFirstChild) {
				if (headerGroupSections[headerGroupSections.length - 1] === header) {
					sections[0].classList.add('section--has-overlay')
					if (sectionFirstChildTransparent && headerTransparent) {
						header.classList.add('color-background-overlay')
						header.classList.forEach((className) => {
							if (
								className.startsWith('color-background-') &&
								className != 'color-background-overlay'
							) {
								header.classList.remove(className)
							}
						})
						header.classList.add(colorScheme)
					}
				} else {
					sections[0].classList.remove('section--has-overlay')
					if (sectionFirstChildTransparent && headerTransparent) {
						header.classList.remove('color-background-overlay')
						//header.classList.remove(colorScheme)
						header.classList.forEach((className) => {
							if (
								className.startsWith('color-background-') &&
								className != 'color-background-overlay'
							) {
								header.classList.remove(className)
							}
						})
					}
				}
			} else {
				sections[0].classList.remove('section--has-overlay')
				if (sectionFirstChildTransparent && headerTransparent) {
					header.classList.remove('color-background-overlay')
					//header.classList.remove(colorScheme)
					header.classList.forEach((className) => {
						if (
							className.startsWith('color-background-') &&
							className != 'color-background-overlay'
						) {
							header.classList.remove(className)
						}
					})
				}
			}
		}
	}

	initHeaderOverlay()

	document.addEventListener('shopify:section:load', initHeaderOverlay)
	document.addEventListener('shopify:section:unload', initHeaderOverlay)
	document.addEventListener('shopify:section:reorder', initHeaderOverlay)
})()
;(function () {
	const productSlider = () => {
		const productSliders = Array.from(
			document.querySelectorAll('.popular-products-section .products-slider')
		)
		if (productSliders.length === 0) return
		productSliders.forEach((slider) => {
			const sectionId = slider.dataset.id
			const perRow = +slider.dataset.perRow
			let perRowTablet
			let perRowDesktop
			let perRowLarge
			const speed = slider.dataset.speed * 1000
			const delay = slider.dataset.delay * 1000
			const autoplay = toBoolean(slider.dataset.autoplay)
			const stopAutoplay = toBoolean(slider.dataset.stopAutoplay)
			const showArrows = toBoolean(slider.dataset.showArrows)
			let autoplayParm = {}
			let arrowsParm = {}
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				}
			}
			if (showArrows) {
				arrowsParm = {
					navigation: {
						nextEl: `#${sectionId} .swiper-button-next`,
						prevEl: `#${sectionId} .swiper-button-prev`,
					},
				}
			}
			const containerOuter =
				(document.body.offsetWidth -
					document.querySelector(`#${sectionId} .popular-product__wrapper`).offsetWidth) /
				2
			
			document.querySelector(
				`#${sectionId} .swiper-pagination`
			).style.padding = `0 ${containerOuter}px 1rem`
			const buttonNext = document.querySelector(
				`#${sectionId} .swiper-button-next`
			)
			const buttonPrev = document.querySelector(
				`#${sectionId} .swiper-button-prev`
			)
			if (buttonNext && buttonPrev) {
				if (window.innerWidth >= 1200) {
					const buttonOffset = +containerOuter - 21

					buttonNext.style.right = `${buttonOffset}px`
					buttonPrev.style.left = `${buttonOffset}px`
				} else {
					buttonNext.style.right = `${containerOuter + 21}px`
					buttonPrev.style.left = `${containerOuter + 21}px`
				}
			}

			const sectionHeader = document.querySelector(
				'.popular-products .popular-product__wrapper'
			)
			let columnGaps = (perRow - 1) * 16
			let oneCard = (sectionHeader.offsetWidth - columnGaps) / perRow
			let perViewRightOffset = +((containerOuter * 2) / oneCard).toFixed(3)

			perViewRightOffset =
				+((containerOuter * 2) / oneCard).toFixed(3) -
				+(perViewRightOffset / oneCard) * 16

			if (perRow == 1) {
				perRowTablet = perRowDesktop = perRowLarge = 1 + perViewRightOffset
			} else {
				let columnGapsTablet = (2 - 1) * 16
				let columnGaps = (3 - 1) * 16
				let oneCard = (sectionHeader.offsetWidth - columnGaps) / 3
				let oneCardTablet = (sectionHeader.offsetWidth - columnGapsTablet) / 2

				let perViewRightOffsetDekstop =
					+((containerOuter * 2) / oneCard).toFixed(3) -
					+(perViewRightOffset / oneCard) * 16
				let perViewRightOffsetTablet =
					+((containerOuter * 2) / oneCardTablet).toFixed(3) -
					+(perViewRightOffset / oneCardTablet) * 16

				perRowTablet = 2 + perViewRightOffsetTablet
				perRowDesktop = 3 + perViewRightOffsetDekstop
				perRowLarge = perRow + perViewRightOffset
			}
			if (perRow == 2) {
				perRowTablet = perRowDesktop = perRowLarge = 2 + perViewRightOffset
			}

			let swiperParms = {
				speed: speed,
				keyboard: true,
				slidesPerView: 1.1,
				spaceBetween: 10,
				slidesOffsetBefore: containerOuter,
				breakpoints: {
					576: {
						slidesPerView: perRowTablet,
					},
					750: {
						spaceBetween: 16,
						slidesPerView: perRowTablet,
					},
					990: {
						spaceBetween: 16,
						slidesPerView: perRowDesktop,
					},
					1200: {
						spaceBetween: 16,
						slidesPerView: perRow + perViewRightOffset,
					},
					1800: {
						spaceBetween: 16,
						slidesPerView: perRowLarge,
					},
					2000: {
						spaceBetween: 16,
						slidesPerView: perRowLarge,
					},
				},
				pagination: {
					el: `#${sectionId} .swiper-pagination`,
					clickable: true,
				},
				...arrowsParm,
				...autoplayParm,
			}

			const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms)
		})
	}

	function toBoolean(string) {
		return string === 'true' ? true : false
	}
	if (document.querySelector('product-recommendations') !== null) {
		const initslider = setInterval(() => {
			if (
				document
					.querySelector('product-recommendations')
					.querySelector('.swiper') !== null
			) {
				if (
					document
						.querySelector('product-recommendations')
						.querySelector('.swiper')
						.classList.contains('swiper-initialized')
				) {
					clearInterval(initslider)
				}
				productSlider()
			}
		}, 100)
	}
	document.addEventListener('shopify:section:load', function () {
		productSlider()
	})
	document.addEventListener('DOMContentLoaded', function () {
		productSlider()
		document.addEventListener('shopify:section:load', function () {
			productSlider()
		})
		window.addEventListener('resize', function () {
			productSlider()
		})
	})
})()

class RecentlyViewedProductsSection extends HTMLElement {
	constructor(element) {
		super()
			this.element = element;
			// this.delegateElement = new Delegate(this.element);
			this.options = JSON.parse(this.getAttribute('data-section-settings'));

			if (this.options['currentProductId']) {
					this.saveCurrentProduct();
			}

			//this.productItemColorSwatch = new ProductItemColorSwatch(this.element);

			this.fetchProducts();
			// this.attachListeners();
	}

	onUnload() {
			if (this.flickityInstance) {
					this.flickityInstance.destroy();
			}

			this.productItemColorSwatch.destroy();

			if (this.resizeObserver) {
					this.resizeObserver.disconnect();
			}
	}

	attachListeners() {
		this.delegateElement.on('click', '[data-action="add-to-cart"]', this.addToCart.bind(this));
		this.delegateElement.on('click', '[data-secondary-action="open-quick-view"]', this.openQuickView.bind(this));
	}

	saveCurrentProduct() {
			let items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
			let currentProductId = this.options['currentProductId'];

			if (!items.includes(currentProductId)) {
					items.unshift(currentProductId);
			}

			try {
					localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, 18)));
			} catch (error) {
					// Ignore errors in incognito mode
			}
	}

	fetchProducts() {
			let queryString = this.getSearchQueryString();
			const _this = this;

			if (queryString === '') return;

			let template = window.theme.pageType === 'index' ? 'recently-viewed-products' : 'static-recently-viewed-products';

			fetch(`${window.routes.searchUrl}?view=${template}&type=product&q=${queryString}`, {
					credentials: 'same-origin',
					method: 'GET'
			}).then(response => response.text())
				.then(content => {
						let tempElement = document.createElement('div');
						tempElement.innerHTML = content;

						_this.querySelector('.recently-viewed-products-placeholder').innerHTML =
								tempElement.querySelector('[data-section-type="recently-viewed-products"] .recently-viewed-products-placeholder').innerHTML;

						_this.parentNode.style.display = 'block';
						//_this.productItemColorSwatch.recalculateSwatches();

						if (window.SPR) {
								window.SPR.initDomEls();
								window.SPR.loadBadges();
						}

						_this.initCarousel();
				});
	}

	getSearchQueryString() {
			let items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

			if (items.includes(this.options['currentProductId'])) {
					items.splice(items.indexOf(this.options['currentProductId']), 1);
			}

			return items.map(item => `id:${item}`).join(' OR ');
	}

	initCarousel() {

		let swiperParms = {
			speed: 1.1 * 1000,
			keyboard: true,
			slidesPerView: 1.05,
			spaceBetween: 10,
			// slidesOffsetBefore: containerOuter,
			breakpoints: {
				375: {
					slidesPerView: 2,
				},
				750: {
					spaceBetween: 16,
					slidesPerView: 2,
				},
				990: {
					spaceBetween: 16,
					slidesPerView: 3,
				},
				1200: {
					spaceBetween: 16,
					slidesPerView: 5,
				},
				1800: {
					spaceBetween: 16,
					slidesPerView: 5,
				},
				2000: {
					spaceBetween: 16,
					slidesPerView: 5,
				},
			},
			// ...paginationParm,
			// ...arrowsParm,
			// ...autoplayParm,
		}
		const swiper = new Swiper(`[data-section-type="recently-viewed-products"] .product-list.swiper`, swiperParms);

			// $('[data-section-type="recently-viewed-products"] .product-list').not('.slick-initialized').slick({
			// 		slidesToShow: 5,
			// 		arrows: true,
			// 		slidesToScroll: 1,
			// 		dots: false,
			// 		touchThreshold: 500,
			// 		responsive: [
			// 				{ breakpoint: 1199, settings: { slidesToShow: 4, slidesToScroll: 1 } },
			// 				{ breakpoint: 1023, settings: { slidesToShow: 3, slidesToScroll: 1 } },
			// 				{ breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
			// 				{ breakpoint: 640, settings: { slidesToShow: 1, slidesToScroll: 1, variableWidth: true } }
			// 		]
			// });

			if (window.ResizeObserver && this.flickityInstance) {
					this.element.querySelectorAll('.product-item').forEach(item => {
							this.resizeObserver.observe(item);
					});
			}
	}

	openQuickView(event, target) {
			let productUrl = new URL(`${window.location.origin}${target.getAttribute('data-product-url')}`);

			if (Responsive.matchesBreakpoint('phone') || Responsive.matchesBreakpoint('tablet')) {
					window.location.href = productUrl.href;
					return false;
			}

			let modal = document.getElementById(target.getAttribute('aria-controls'));
			modal.classList.add('is-loading');
			productUrl.searchParams.set('view', 'quick-view');

			fetch(productUrl.href, {
					credentials: 'same-origin',
					method: 'GET'
			}).then(response => response.text())
				.then(content => {
						modal.querySelector('.modal__inner').innerHTML = content;
						modal.classList.remove('is-loading');

						let modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]'));

						let doCleanUp = () => {
								modalProductSection.onUnload();
								modal.removeEventListener('modal:closed', doCleanUp);
						};

						modal.addEventListener('modal:closed', doCleanUp);
				});
	}

	addToCart(event, target) {
			if (window.theme.cartType === 'page') return;

			event.preventDefault();
			event.stopPropagation();

			target.setAttribute('disabled', 'disabled');
			document.dispatchEvent(new CustomEvent('theme:loading:start'));

			let formElement = target.closest('form[action*="/cart/add"]');

			fetch(`${window.routes.cartAddUrl}.js`, {
					body: JSON.stringify(Form.serialize(formElement)),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest'
					}
			}).then(response => {
					target.removeAttribute('disabled');

					if (response.ok) {
							this.element.dispatchEvent(new CustomEvent('product:added', {
									bubbles: true,
									detail: {
											button: target,
											variant: null,
											quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
									}
							}));
					} else {
							document.dispatchEvent(new CustomEvent('theme:loading:end'));
					}
			});
	}
}

customElements.define('recently-viewed-products', RecentlyViewedProductsSection);


if (!customElements.get('video-section')) {
	class VideoSection extends HTMLElement {
		constructor() {        
			super();
			this.options = JSON.parse(this.getAttribute('data-section-settings'));

			this.attachListeners();

			this.querySelector('.video-carousel-slider') && (this.initslider());
		}

		attachListeners() {			
			const this_main = this;
			this.querySelectorAll('[data-action="play-video"]').forEach(function(element){
				element.addEventListener('click', this_main.playVideo.bind(this));
			});			
		}

		playVideo(event) {
			// Start the video by setting the iframe source
				
			let target = event.target.closest('.video-item');
			console.log(event, target)
			const iframe = target.querySelector('iframe');
			const video = target.querySelector('video');
			if (iframe) {
				iframe.src = iframe.getAttribute('data-src');
				target.classList.add('is-playing');
			}
			if (video) {
				video.src = video.getAttribute('data-src');
				target.classList.add('is-playing');
			}

			// Handle slick slider autoplay pause
			const slickContainer = target.closest('.slick-initialized');
			if (slickContainer) {
				const $slick = $(slickContainer);
				if ($slick[0].slick.options.autoplay) {
					$slick.slick('slickPause');
					$slick.attr('data-slickautoplay', true);
				}
			}
		}

		initslider(){
			
			$(this.querySelector('.video-carousel-slider')).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				centerPadding: '80px',
				dots: false,
				centerMode: true,
				arrows: true,
				focusOnSelect: true,
				autoplay: !0,
				autoplaySpeed: 5000,
				touchThreshold: 500,
				responsive: [
					{
						breakpoint: 990,
						settings: {
							centerPadding: '30px'
						}
					},
					{
						breakpoint: 750,
						settings: {
							centerPadding: '20px'
						}
					}
				]
			});

			$(this.querySelector('.video-carousel-slider')).on('afterChange', function (event, slick, currentSlide) {
				$(event.currentTarget)
					.find('.slick-slide:not(.slick-current) iframe[src]')
					.each(function () {
						$(this).removeAttr('src');
						$(this).closest('.is-playing').removeClass('is-playing');
						if ($(event.currentTarget).attr('data-slickautoplay')) {
							$(event.currentTarget).slick('slickPlay');
							$(event.currentTarget).removeAttr('data-slickautoplay');
						}
					});
			});

		}
	}
	
	customElements.define('video-section', VideoSection);	
}

class textWithIconsSection {
	constructor(element) {		
		this.flickityInstance = new Flickity(element.querySelector('.text-with-icons'), {
			pageDots: true,
			prevNextButtons: false,
			wrapAround: true,
			autoPlay: 5000,
			watchCSS: true
		});
	}
}
document.querySelector('[data-section-type="text-with-icons"]') && (
	text_with_icons_section = new textWithIconsSection(document.querySelector('[data-section-type="text-with-icons"]'))
);


function formatMoney(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}
	let value = "";
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	const formatString = format || theme.moneyFormat;

	function formatWithDelimiters(
		number,
		precision = 2,
		thousands = ",",
		decimal = ".",
	) {
		if (isNaN(number) || number == null) {
			return 0;
		}

		number = (number / 100.0).toFixed(precision);

		const parts = number.split(".");
		const dollarsAmount = parts[0].replace(
			/(\d)(?=(\d\d\d)+(?!\d))/g,
			`$1${thousands}`,
		);
		const centsAmount = parts[1] ? decimal + parts[1] : "";

		return dollarsAmount + centsAmount;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiters(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiters(cents, 0);
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiters(cents, 2, ".", ",");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiters(cents, 0, ".", ",");
			break;
	}

	return formatString.replace(placeholderRegex, value);
}
